/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-shadow */
// eslint-disable-next-line react-hooks/exhaustive-deps
import React, { useCallback, useEffect, useState } from 'react';
import {
  Box,
  GDSStyleObject,
  StackLayout,
  Modal,
  Button,
  HeadingText,
  Card,
  ParagraphText,
} from '@leagueplatform/genesis-core';
import {
  getAccessToken,
  putAccessToken,
} from '@leagueplatform/engen-capability-shared-library/src/utils/api';
import { SuccessModal } from '@leagueplatform/engen-capability-shared-library/src/components/layouts/successModal';
import { DynamicModal } from '@leagueplatform/engen-capability-shared-library/src/components/layouts/dynamicModal';
import { EmailVerification } from '@leagueplatform/engen-capability-shared-library/src/components/email-verification/emailVerification';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import {
  LinkLegacy as Link,
  useNavigateLegacy as useNavigate,
} from '@leagueplatform/routing';
import * as CONSTANTS from '../../utils/constant';
import {
  CONTACT_INFO_LIBRARY_ASSET_KEYS,
  FormInput,
  ContactFieldDisabled,
  AllContactValue,
} from '../../types/contactInfo-library.types';
import { FormSection } from './formSection';
import {
  isEmpty,
  isValidateEmail,
  isValidatePhoneLength,
  isValidateZipLength,
  isNoSpace,
  formatPhoneNumber,
  getLoginBrowser,
} from '../../utils/helper';
import { contactInfoLibrary } from '../../contactInfo-library.config';

export const showDescption = (memberType: string) =>
  memberType === 'ACAOnExchange'
    ? CONSTANTS.ACA_CONTACT_DESCRIPTION
    : memberType === 'CHIP'
    ? CONSTANTS.CHIP_CONTACT_DESCRIPTION
    : memberType === 'ACAOffExchange'
    ? CONSTANTS.ACA_OFF_CONTACT_DESCRIPTION
    : memberType === 'ACASmallGroup'
    ? CONSTANTS.ACA_SMALL_CONTACT_DESCRIPTION
    : CONSTANTS.COMMERCIAL_CONTACT_DESCRIPTION;

export function ContactInfoLibraryComponent(props: any) {
  const { showModal, setShowModal, plans, services } = props;
  const [contactModalOpen, setContactModalOpen] = useState<boolean>(true);
  const [backModalOpen, setBackModalOpen] = useState<boolean>(false);
  const [validFormFlag, setValidFormFlag] = useState<boolean>(false);
  const [saveBtnDisable, setSaveBtnDisable] = useState<boolean>(true);
  const [confirmEmail, setConfirmEmail] = useState<boolean>(false);
  const [openSuccess, setOpenSuccess] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');
  const [apiFailure, setApiFailure] = useState<boolean>(false);
  const [emailAuthendicated, setEmailAuthendicated] = useState<string>('');
  const [initialState, setInitialState] = useState<FormInput>();
  const [oldEmail, setOldEmail] = useState<string>('');
  const [contactDataLoading, setContactDataLoading] = useState<boolean>(false);
  const [contactData, setContactData] = useState<any[]>([]);
  const [showFailedAPI] = useState<boolean>(true);
  const [description, setDescription] = useState<string>('');
  const [userType, setUserType] = useState<string>('');
  const [newEmailAdded, setNewEmailAdded] = useState<boolean>(false);
  const [openEmailAddress, setopenEmailAddress] = useState<boolean>(false);
  const config = contactInfoLibrary.getConfig();
  const navigate = useNavigate();
  const highmarkURL = config.HIGHMARK_API_URL;
  const contactInfoURL = `${highmarkURL}/digital/v1/members/contact-information/contacts`;
  const backGrayIcon = useStaticAsset(
    CONTACT_INFO_LIBRARY_ASSET_KEYS.BACK_GRAY_ICON,
  );

  const [formInputState, setFormInputState] = useState<FormInput>({
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    homePhone: '',
    workPhone: '',
    mobilePhone: '',
    email: '',
  });

  const [formInputErrorState, setFormInputErrorState] = useState<FormInput>({
    address1: '',
    city: '',
    state: '',
    zip: '',
    homePhone: '',
    workPhone: '',
    mobilePhone: '',
    email: '',
  });

  const [allContactNumberValue, setAllContactNumberValue] =
    useState<AllContactValue>({
      mobilePhone: '',
      homePhone: '',
      workPhone: '',
      textPhone: '',
    });

  const [formDisableField, setFormDisableField] =
    useState<ContactFieldDisabled>({
      address1Disable: false,
      address2Disable: false,
      cityDisable: false,
      stateDisable: false,
      zipDisable: false,
      homePhoneDisable: false,
      workPhoneDisable: false,
      mobilePhoneDisable: false,
      emailDisable: false,
    });

  const handleSaveBtnClick = () => {
    setValidFormFlag(true);
  };

  const saveApi = () => {
    setSaveBtnDisable(true);

    const inputObject = { ...contactData[0] };
    inputObject.addressData[0].line1 = formInputState.address1;
    inputObject.addressData[0].line2 = formInputState.address2;
    inputObject.addressData[0].city = formInputState.city;
    inputObject.addressData[0].state = formInputState.state;
    inputObject.addressData[0].postalCode = formInputState.zip;

    const tempContactPoints = [
      {
        type: 'Phone',
        use: 'Home',
        value: formInputState.homePhone.replace(/[^0-9]+/g, ''),
      },
      {
        type: 'Phone',
        use: 'Work',
        value: formInputState.workPhone.replace(/[^0-9]+/g, ''),
      },
      {
        type: 'Text',
        use: 'Mobile',
        value: formInputState.mobilePhone.replace(/[^0-9]+/g, ''),
      },
      {
        type: 'Email',
        use: 'Member Supplied',
        value: formInputState.email,
      },
    ];
    delete inputObject.contactPoints;
    const payload = {
      memberDetail: inputObject,
      contactPoints: tempContactPoints,
    };
    putAccessToken(contactInfoURL, payload, '').then((result: any) => {
      setContactDataLoading(false);
      if (result?.memberContactsResponse) {
        setOpenSuccess(true);
        setSaveBtnDisable(false);
      }
      if (result.errMsg) {
        setApiFailure(true);
        setSaveBtnDisable(false);
      }
    });
  };

  const updateSaveBtnStatus = (
    formInputState: FormInput,
    formInputErrorState: FormInput,
  ) =>
    formInputState.address1.length > 0 &&
    formInputState.zip.length === CONSTANTS.ZIP_MAX_LENGTH &&
    formInputState.state.length > 0 &&
    formInputState.city.length > 0 &&
    formInputState.email.length > 0 &&
    (formInputState.homePhone.length === 0 ||
      formInputState.homePhone.length === CONSTANTS.PHONE_MAX_LENGTH) &&
    formInputErrorState.homePhone === '' &&
    (formInputState.workPhone.length === 0 ||
      formInputState.workPhone.length === CONSTANTS.PHONE_MAX_LENGTH) &&
    formInputErrorState.workPhone === '' &&
    (formInputState.mobilePhone.length === 0 ||
      formInputState.mobilePhone.length === CONSTANTS.PHONE_MAX_LENGTH) &&
    formInputErrorState.mobilePhone === '' &&
    formInputErrorState.address1 === '' &&
    formInputErrorState.city === '' &&
    formInputErrorState.email === '' &&
    formInputErrorState.zip === '' &&
    formInputErrorState.state === '';

  useEffect(() => {
    if (updateSaveBtnStatus(formInputState, formInputErrorState)) {
      setSaveBtnDisable(false);
    } else {
      setSaveBtnDisable(true);
    }
  }, [formInputErrorState, formInputState]);

  useEffect(() => {
    if (validFormFlag) {
      saveApi();
    }
  }, [validFormFlag]); // eslint-disable-line react-hooks/exhaustive-deps

  const updateErrorState = (value: string, id: string, type: string) => {
    if (id === 'homePhone' || id === 'workPhone' || id === 'mobilePhone') {
      !isEmpty(value) && isValidatePhoneLength(value)
        ? updateErrorMessage(id, CONSTANTS.PHONE_ERR)
        : updateErrorMessage(id, '');
    } else if (id === 'zip') {
      !isEmpty(value) && isValidateZipLength(value)
        ? updateErrorMessage(id, CONSTANTS.ZIP_ERR)
        : type === 'blur' && isEmpty(value)
        ? updateErrorMessage(id, CONSTANTS.GENERAL_ERR)
        : updateErrorMessage(id, '');
    } else if (id === 'email') {
      !isEmpty(value) && !isValidateEmail(value)
        ? updateErrorMessage(id, CONSTANTS.VALID_EMAIL)
        : type === 'blur' && isEmpty(value)
        ? updateErrorMessage(id, CONSTANTS.GENERAL_ERR)
        : updateErrorMessage(id, '');
    } else {
      !isEmpty(value.trim())
        ? updateErrorMessage(id, '')
        : id !== 'address2' &&
          type === 'blur' &&
          updateErrorMessage(id, CONSTANTS.GENERAL_ERR);
    }
  };

  const onBlurField = (event: any) => {
    updateErrorState(event.target.value, event.target.id, 'blur');
  };

  const onKeyPressField = (event: any) => {
    updateErrorState(event.target.value, event.target.id, 'keypress');
  };

  const handleChangeInput = (e: any) => {
    e.persist();
    if (e.target.id === 'state') {
      updateErrorMessage(e.target.id, '');
    }
    setFormInputState(
      (prevState) =>
        ({
          ...prevState,
          [e.target.id]: isNoSpace(e.target.value) ? '' : e.target.value,
        } as Pick<FormInput, keyof FormInput>),
    );
  };

  const updateErrorMessage = (formField: string, msg: string) => {
    setValidFormFlag(false);
    setFormInputErrorState((prevState) => ({
      ...prevState,
      [formField]: msg,
    }));
  };

  const handleClickShowEmail = () => {
    setConfirmEmail(true);
    setEmail(oldEmail);
  };

  const handleCloseSuccess = () => {
    setOpenSuccess(false);
    setFormInputState((prevState) => ({
      ...prevState,
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      homePhone: '',
      workPhone: '',
      mobilePhone: '',
      email: '',
    }));
    getContactDetails(contactInfoURL);
  };

  const handleCloseBackModal = () => {
    setBackModalOpen(false);
  };

  const handleCloseFailourModal = () => {
    setApiFailure(false);
  };

  const handleBackButtonClick = () => {
    const initialInputState = JSON.stringify(initialState);
    const formCurrentInputState = JSON.stringify(formInputState);
    if (initialInputState !== formCurrentInputState) {
      setBackModalOpen(true);
    } else {
      setBackModalOpen(false);
      if (setShowModal !== undefined) setShowModal(false);
      setContactModalOpen(false);
      navigate('/account-management', { replace: true });
    }
  };

  const getClient = (plans: any) => {
    let planDetail;
    const currentYear =
      plans &&
      plans?.length > 0 &&
      plans?.filter(
        (plan: any) =>
          plan.planType === 'medical' &&
          plan.planYear === 'current' &&
          (plan?.hcrProduct === 'OFF' ||
            plan?.hcrProduct === 'ON' ||
            plan?.mediGapIndicator === 'true' ||
            plan?.medicareAdvIndicator === 'true'),
      );

    if (currentYear.length === 0) {
      const pastYear =
        plans &&
        plans?.length > 0 &&
        plans?.filter(
          (plan: any) =>
            plan.planType === 'medical' &&
            plan.planYear === 'past' &&
            (plan?.hcrProduct === 'OFF' ||
              plan?.hcrProduct === 'ON' ||
              plan?.mediGapIndicator === 'true' ||
              plan?.medicareAdvIndicator === 'true'),
        );
      if (pastYear.length === 0) {
        planDetail =
          plans &&
          plans?.length > 0 &&
          plans?.filter(
            (plan: any) =>
              plan.planType === 'medical' &&
              plan.planYear === 'future' &&
              (plan?.hcrProduct === 'OFF' ||
                plan?.hcrProduct === 'ON' ||
                plan?.mediGapIndicator === 'true' ||
                plan?.medicareAdvIndicator === 'true'),
          );
      } else {
        planDetail = pastYear;
      }
    } else {
      planDetail = currentYear;
    }

    return planDetail[0];
  };

  const getContactDetails = (url: any) => {
    setContactDataLoading(true);
    getAccessToken(url, '').then((result: any) => {
      if (result?.memberContactsResponse) {
        setContactData(result.memberContactsResponse);
        const contactDetail = result.memberContactsResponse[0]?.contactPoints;
        const addressDetail = result.memberContactsResponse[0]?.addressData[0];

        setFormInputState((prevState) => ({
          ...prevState,
          address1: addressDetail.line1,
          address2: addressDetail.line2,
          city: addressDetail.city,
          state: addressDetail.state,
          zip: addressDetail.postalCode,
        }));

        const initialFormInputState = {
          address1: addressDetail.line1,
          address2: addressDetail.line2,
          city: addressDetail.city,
          state: addressDetail.state,
          zip: addressDetail.postalCode,
          homePhone: '',
          workPhone: '',
          mobilePhone: '',
          email: '',
        };

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const data =
          contactDetail &&
          contactDetail.length > 0 &&
          contactDetail.map((item: any) => {
            if (item.use === 'Member Supplied' && item.type === 'Email') {
              setEmail(item?.value);
              setOldEmail(item?.value);
              setEmailAuthendicated(item?.authentication);
              setFormInputState((prevState) => ({
                ...prevState,
                email: item?.value,
              }));
              initialFormInputState.email = item?.value;
            }

            if (item.use === 'Home' && item.type === 'Phone') {
              setFormInputState((prevState) => ({
                ...prevState,
                homePhone: formatPhoneNumber(item?.value),
              }));
              setAllContactNumberValue((prevState: any) => ({
                ...prevState,
                homePhone: item.value,
              }));
              initialFormInputState.homePhone = formatPhoneNumber(item?.value);
            }
            if (item.use === 'Work' && item.type === 'Phone') {
              setFormInputState((prevState) => ({
                ...prevState,
                workPhone: formatPhoneNumber(item?.value),
              }));
              setAllContactNumberValue((prevState: any) => ({
                ...prevState,
                workPhone: item.value,
              }));
              initialFormInputState.workPhone = formatPhoneNumber(item?.value);
            }
            if (item.use === 'Mobile' && item.type === 'Phone') {
              setFormInputState((prevState) => ({
                ...prevState,
                mobilePhone: formatPhoneNumber(item?.value),
              }));
              setAllContactNumberValue((prevState: any) => ({
                ...prevState,
                mobilePhone: item.value,
              }));
              initialFormInputState.mobilePhone = formatPhoneNumber(
                item?.value,
              );
            } else if (item.use === 'Mobile' && item.type === 'Text') {
              setFormInputState((prevState) => ({
                ...prevState,
                mobilePhone: formatPhoneNumber(item?.value),
              }));
              setAllContactNumberValue((prevState: any) => ({
                ...prevState,
                mobilePhone: item.value,
                textPhone: item.value,
              }));
              initialFormInputState.mobilePhone = formatPhoneNumber(
                item?.value,
              );
            }
            setInitialState(initialFormInputState);
            return item;
          });
        setContactDataLoading(false);
        // getPlanAPIData(planAPIUrl);
      } else if (result.errMsg) {
        setContactDataLoading(false);
        setApiFailure(true);
      } else {
        setContactDataLoading(false);
        setApiFailure(true);
      }
    });
  };

  useEffect(() => {
    getContactDetails(contactInfoURL);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactInfoURL]);

  useEffect(() => {
    localStorage.removeItem('sendCount');
  }, []);

  const enableOrDisableFormFields = useCallback(
    (type: string) => {
      setUserType(type);
      let phoneEmailUpdate = true;
      if (type === 'ACAOnExchange' || type === 'CMS') setSaveBtnDisable(true);
      else if (type === 'CHIP' || type === 'ACAOffExchange') {
        phoneEmailUpdate = false;
        if (updateSaveBtnStatus(formInputState, formInputErrorState)) {
          setSaveBtnDisable(false);
        }
      } else {
        phoneEmailUpdate = false;
        if (updateSaveBtnStatus(formInputState, formInputErrorState)) {
          setSaveBtnDisable(false);
        }
      }

      setDescription(showDescption(type));

      setFormDisableField((prevState) => ({
        ...prevState,
        address1Disable: true,
        address2Disable: true,
        cityDisable: true,
        stateDisable: true,
        zipDisable: true,
        homePhoneDisable: phoneEmailUpdate,
        workPhoneDisable: phoneEmailUpdate,
        mobilePhoneDisable: phoneEmailUpdate,
        emailDisable: phoneEmailUpdate,
      }));
    },
    [formInputErrorState, formInputState],
  );

  useEffect(() => {
    const newPlans = getClient(plans);
    if (newPlans && ![' ', null, undefined].includes(newPlans?.hcrProduct)) {
      if (newPlans?.hcrProduct === 'OFF') {
        enableOrDisableFormFields('ACAOffExchange');
      }
      if (newPlans?.hcrProduct === 'ON') {
        enableOrDisableFormFields('ACAOnExchange');
      }
    } else if (
      newPlans?.mediGapIndicator === 'true' ||
      newPlans?.medicareAdvIndicator === 'true'
    ) {
      enableOrDisableFormFields('CMS');
    } else {
      const chipIndicator =
        services &&
        services.length > 0 &&
        services.filter((item: { name: string }) => item.name === 'chip');
      if (
        chipIndicator &&
        chipIndicator.length &&
        chipIndicator[0].name === 'chip' &&
        chipIndicator[0].isChip === 'Y'
      ) {
        enableOrDisableFormFields('CHIP');
      } else {
        enableOrDisableFormFields('OTHER');
      }
    }
  }, [plans, services, enableOrDisableFormFields]);

  useEffect(() => {
    setFormInputState((prevState) => ({
      ...prevState,
      email,
    }));

    if (initialState?.email) {
      initialState.email = email;
    }
    setNewEmailAdded(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newEmailAdded]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!contactDataLoading) {
      const close = (e: any) => {
        if (e.keyCode === 27) {
          const initialInputState = JSON.stringify(initialState);
          const formCurrentInputState = JSON.stringify(formInputState);
          if (initialInputState !== formCurrentInputState) {
            setBackModalOpen(true);
          } else {
            setBackModalOpen(false);
            if (setShowModal !== undefined) setShowModal(false);
            setContactModalOpen(false);
            navigate('/account-management', { replace: true });
          }
        }
      };
      window.addEventListener('keydown', close);
      return () => window.removeEventListener('keydown', close);
    }
  }, [
    setShowModal,
    initialState,
    formInputState,
    navigate,
    contactDataLoading,
  ]);
  return (
    <Box>
      <Modal.Root
        open={showModal || contactModalOpen}
        onOpenChange={() => {
          setContactModalOpen((previous) => !previous);
        }}
      >
        <Modal.Content
          showCloseButton={false}
          padding={{
            '@initial': '30px 150px',
            '@laptop': '30px 100px',
            '@tablet': '30px 30px',
            '@mobile': '0',
            '@mobileLandscape': '30px',
          }}
          css={
            {
              borderRadius: '12px',
              background: '#fff',
              height: 'auto',
              overflowY: 'auto',
              '.genesis.css-3z5yjv': {
                position: 'relative !important',
              },
            } as GDSStyleObject
          }
          width={{ '@initial': '65%', '@laptop': '80%', '@mobile': '100%' }}
          onInteractOutside={(e: any) => e.preventDefault()}
        >
          <Box
            css={{
              height: 'auto',
              minHeight: '500px',
              padding: '$two $three',
              '@mobile': {
                maxWidth: '100vw',
                width: '100%',
                height: '100vh',
                overflow: 'auto !important',
                paddingTop: ['Safari'].includes(getLoginBrowser())
                  ? '70px'
                  : '32px',
                '.GDS-c-biBNXN': {
                  height: 'auto !important',
                },
              },
            }}
          >
            <Box>
              <Button
                size="small"
                role="dialog"
                icon={backGrayIcon as string}
                onClick={handleBackButtonClick}
                css={{
                  '.GDS-c-PJLV': {
                    fontSize: '$headingThree',
                    '@tablet': {
                      fontSize: '$headingFour',
                    },
                    '@mobile': {
                      fontSize: '$headingFour',
                    },
                    fontWeight: 700,
                  },
                  '.GDS-c-UazGY': {
                    paddingRight: '25px',
                    '@mobile': {
                      paddingRight: '10px',
                      marginLeft: '-5px',
                    },
                  },
                  background: 'none',
                  color: '#66717A',
                  padding: '5px',
                  margin: '-5px',
                  '&:hover,&:active,&:focus': {
                    background: 'none',
                  },
                  letterSpacing: 0.25,
                  marginBottom: '20px',
                  position: 'relative',
                  left: '-40px',
                  '@mobile': {
                    marginBottom: '10px',
                    left: '0px',
                  },
                }}
                data-testid="back-btn"
              >
                {CONSTANTS.BACK_TITLE}
              </Button>
            </Box>
            {contactDataLoading ? (
              <LoadingIndicator />
            ) : (
              <>
                <HeadingText
                  level="display"
                  role="heading"
                  tabIndex={0}
                  size="sm"
                  css={
                    {
                      fontSize: '$headingOne',
                      '@tablet': {
                        fontSize: '$headingTwo',
                      },
                      '@mobile': {
                        fontSize: '$headingThree',
                      },
                      '@mobileLandscape': {
                        fontSize: '$headingTwo',
                      },
                      padding: '20px 0px',
                      color: '#2C3135',
                      letterSpacing: '0.25px',
                    } as GDSStyleObject
                  }
                  data-testid="title"
                >
                  {CONSTANTS.CONTACT_INFORMATION}
                </HeadingText>
                <Modal.Description>
                  <ParagraphText
                    css={
                      {
                        fontSize: '$bodyOne',
                        lineHeight: '40px',
                        letterSpacing: '0.25',
                        color: 'rgba(0, 0, 0, 0.8)',
                        '@mobile': {
                          lineHeight: '24px',
                        },
                      } as GDSStyleObject
                    }
                    data-testid="test-description"
                  >
                    {userType === 'CMS' ? (
                      <>
                        {CONSTANTS.CMS_CONTACT_DESCRIPTION1}{' '}
                        <span
                          aria-hidden="true"
                          style={{ cursor: 'pointer', color: '#0074C9' }}
                        >
                          <Link to="/support">
                            {CONSTANTS.CMS_CONTACT_DESCRIPTION2}
                          </Link>
                        </span>
                      </>
                    ) : (
                      description
                    )}
                  </ParagraphText>
                </Modal.Description>
                <Card.Flat
                  css={
                    {
                      margin: '20px 0px',
                      borderRadius: '0px',
                    } as GDSStyleObject
                  }
                >
                  <FormSection
                    formInputState={formInputState}
                    formDisableField={formDisableField}
                    handleChangeInput={handleChangeInput}
                    onBlurField={onBlurField}
                    onKeyPressField={onKeyPressField}
                    formInputErrorState={formInputErrorState}
                  />
                  <StackLayout
                    css={{ textAlign: 'left', paddingTop: '5px' }}
                    horizontalAlignment="start"
                  >
                    {formInputState?.email !== '' &&
                      formInputState?.email &&
                      emailAuthendicated !== 'Authenticated' &&
                      email === formInputState?.email && (
                        <ParagraphText
                          css={
                            {
                              fontSize: '$bodyOne',
                              lineHeight: '24px',
                              letterSpacing: '-1.1px',
                              color: '#000000CC',
                              paddingBottom: '10px',
                            } as GDSStyleObject
                          }
                        >
                          {CONSTANTS.VERIFY_EMAIL_TEXT}{' '}
                          <Button
                            data-testid="email-verify-text"
                            onClick={handleClickShowEmail}
                            aria-hidden="true"
                            tabIndex={0}
                            className="verify-button"
                            css={{
                              cursor: 'pointer',
                              color: '#0074C9',
                              fontWeight: '600',
                              background: 'none !important',
                              border: 'none',
                              borderRadius: '3px',
                              padding: '0px',
                              margin: '0px 2px',
                            }}
                          >
                            {CONSTANTS.VERIFY_EMAIL_TEXT2}
                          </Button>
                        </ParagraphText>
                      )}
                    {emailAuthendicated === 'Authenticated' &&
                      email === formInputState?.email && (
                        <ParagraphText
                          css={
                            {
                              fontSize: '16px',
                              lineHeight: '24px',
                              letterSpacing: '-1.1%',
                              fontWeight: 400,
                              color: '#1D8747',
                            } as GDSStyleObject
                          }
                        >
                          {CONSTANTS.VERIFIED_EMAIL_TEXT}
                        </ParagraphText>
                      )}
                  </StackLayout>
                </Card.Flat>
                <StackLayout
                  css={{ textAlign: 'center', marginTop: '27px' }}
                  horizontalAlignment="center"
                >
                  <ParagraphText
                    css={
                      {
                        fontSize: '$bodyOne',
                        lineHeight: '24px',
                        letterSpacing: '-1.1px',
                        color: ['CMS', 'ACAOnExchange'].includes(userType)
                          ? '#8996A1'
                          : '#000000CC',
                      } as GDSStyleObject
                    }
                  >
                    {CONSTANTS.REQUIRED_FIELDS}
                  </ParagraphText>
                </StackLayout>
                <StackLayout
                  css={{ textAlign: 'center', marginTop: '80px' }}
                  horizontalAlignment="center"
                >
                  <Button
                    disabled={saveBtnDisable}
                    data-testid="save-btn"
                    onClick={handleSaveBtnClick}
                    css={
                      {
                        padding: '12px 32px',
                        fontWeight: 700,
                        color: '#fff',
                        letterSpacing: '-0.2px',
                        fontSize: 16,
                        gap: '8px',
                        '&:disabled': {
                          background: '#E8EAED',
                          color: '#5A6B6D',
                        },
                      } as GDSStyleObject
                    }
                  >
                    {CONSTANTS.SAVE_BTN}
                  </Button>
                </StackLayout>

                <EmailVerification
                  setConfirmEmail={setConfirmEmail}
                  confirmEmail={confirmEmail}
                  email={email}
                  setEmail={setEmail}
                  setOldEmail={setOldEmail}
                  oldEmail={oldEmail}
                  contactDataLoading={contactDataLoading}
                  contactData={contactData}
                  allContactNumberValue={allContactNumberValue}
                  showDiffEmailBtn={
                    !['CMS', 'ACAOnExchange'].includes(userType)
                  }
                  getContactDetails={getContactDetails}
                  setNewEmailAdded={setNewEmailAdded}
                  newEmailAdded={newEmailAdded}
                  openEmailAddress={openEmailAddress}
                  setopenEmailAddress={setopenEmailAddress}
                />

                <SuccessModal
                  open={openSuccess}
                  onClose={handleCloseSuccess}
                  heading={CONSTANTS.SUCCESS}
                  description={CONSTANTS.NEW_EMAIL_ADDRESS_SAVED}
                  btnText={CONSTANTS.OK}
                />

                <DynamicModal
                  open={backModalOpen || apiFailure}
                  type="API_FAILED"
                  showDiffEmailBtn={showFailedAPI}
                  onClose={
                    backModalOpen
                      ? handleCloseBackModal
                      : handleCloseFailourModal
                  }
                  heading={CONSTANTS.ATTENTION}
                  description={
                    backModalOpen
                      ? CONSTANTS.ATTENTION_DESC
                      : CONSTANTS.API_ERROR_DESC
                  }
                  saveBtn={CONSTANTS.OK}
                />
              </>
            )}
          </Box>
        </Modal.Content>
      </Modal.Root>
    </Box>
  );
}
